var _circle, _circle2, _circle3, _path, _g, _circle4, _circle5, _circle6, _path2, _g2, _circle7, _circle8, _circle9, _path3, _g3, _circle10, _circle11, _circle12, _path4, _g4, _circle13, _circle14, _circle15, _path5, _g5, _circle16, _circle17, _circle18, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlannerBadges = function SvgPlannerBadges(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 604,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 266.877,
    cy: 313.372,
    r: 59.731,
    fill: "#fff",
    stroke: "#FFC50A",
    strokeWidth: 4.654
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.877,
    cy: 313.372,
    r: 50.422,
    fill: "#E2F7FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.877,
    cy: 256.744,
    r: 11.636,
    fill: "#FFC50A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m265.375 254.898 1.088-2.205a.388.388 0 0 1 .696 0l1.088 2.205 2.432.353a.388.388 0 0 1 .216.662l-1.76 1.716.415 2.423a.388.388 0 0 1-.563.409l-2.176-1.144-2.176 1.144a.388.388 0 0 1-.563-.409l.416-2.423-1.76-1.716a.388.388 0 0 1 .215-.662l2.432-.353Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PlannerBadges_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.2 340.696a9.094 9.094 0 0 1 .573-4.979 9.783 9.783 0 0 1 3.176-4.148 9.936 9.936 0 0 1 4.876-1.947 9.806 9.806 0 0 1 6.55 1.678 9.638 9.638 0 0 1 3.865 5.498 6.662 6.662 0 0 1 2.308-.425 6.357 6.357 0 0 1 3.516 1.07 6.262 6.262 0 0 1 2.318 2.828.744.744 0 0 1 .042.359.772.772 0 0 1-.758.668h-25.732a.756.756 0 0 1-.476-.171.741.741 0 0 1-.258-.431Z",
    fill: "#007E86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.165 300.566h-9.162v40.165h9.162v-40.165Z",
    fill: "#352269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.776 317.194-3.113-3.082-10.072 9.972 3.113 3.082 10.072-9.972Z",
    fill: "#352269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.297 340.412a13.199 13.199 0 0 0-.841-7.087 14.074 14.074 0 0 0-4.516-5.979 14.272 14.272 0 0 0-6.972-2.844 14.1 14.1 0 0 0-9.424 2.414 13.853 13.853 0 0 0-5.554 7.915 9.023 9.023 0 0 0-3.185-.584 9.007 9.007 0 0 0-5.055 1.502 8.87 8.87 0 0 0-3.32 4.061 1.088 1.088 0 0 0 .51 1.356c.157.084.332.129.51.132h36.773c.256 0 .503-.088.699-.25a1.08 1.08 0 0 0 .375-.636Z",
    fill: "#00B0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.402 311.285a6.622 6.622 0 0 0 4.634-1.797 6.493 6.493 0 0 0 2.041-4.493c0-2.683-1.077-5.256-2.993-7.153a10.266 10.266 0 0 0-7.225-2.963h-.125a20.014 20.014 0 0 0-6.632-12.734 20.392 20.392 0 0 0-13.518-5.112c-4.987 0-9.8 1.82-13.517 5.112a20.014 20.014 0 0 0-6.632 12.734h-.125a10.286 10.286 0 0 0-7.2 2.93 10.083 10.083 0 0 0-3.036 7.098 6.49 6.49 0 0 0 2.017 4.556 6.624 6.624 0 0 0 4.676 1.822h47.635Z",
    fill: "#007E86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.448 317.698a2.244 2.244 0 0 0 2.255-2.232 2.244 2.244 0 0 0-2.255-2.232 2.244 2.244 0 0 0-2.255 2.232 2.244 2.244 0 0 0 2.255 2.232Z",
    fill: "#8D83BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.078 304.995c0-2.683-1.076-5.256-2.993-7.153a10.267 10.267 0 0 0-7.225-2.964h-.125a20.034 20.034 0 0 0-4.149-10.189 20.33 20.33 0 0 0-8.932-6.518 20.305 20.305 0 0 0-8.925 6.474 19.996 19.996 0 0 0-4.174 10.145h-.143a10.285 10.285 0 0 0-7.231 2.962c-1.919 1.897-3 4.47-3.005 7.154a6.512 6.512 0 0 0 2.053 4.495 6.637 6.637 0 0 0 4.64 1.795h33.535a6.621 6.621 0 0 0 4.603-1.765 6.489 6.489 0 0 0 2.071-4.436Z",
    fill: "#00B0AC"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.084,
    cy: 424.736,
    r: 59.731,
    fill: "#fff",
    stroke: "#FFC50A",
    strokeWidth: 4.654
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.083,
    cy: 424.736,
    r: 50.422,
    fill: "#E2F7FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.084,
    cy: 368.108,
    r: 11.636,
    fill: "#FFC50A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m165.581 366.263 1.089-2.205a.388.388 0 0 1 .695 0l1.088 2.205 2.433.353a.388.388 0 0 1 .215.661l-1.76 1.717.415 2.423a.388.388 0 0 1-.563.409l-2.176-1.145-2.176 1.145a.388.388 0 0 1-.563-.409l.416-2.423-1.76-1.717a.388.388 0 0 1 .215-.661l2.432-.353Z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PlannerBadges_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.435 448.738a7.763 7.763 0 0 0-.486-4.245c-1.141-2.819-3.759-4.883-6.779-5.185-4.195-.42-7.802 2.315-8.776 6.124a5.344 5.344 0 0 0-1.879-.352 5.303 5.303 0 0 0-4.916 3.305.64.64 0 0 0 .587.873h21.612a.63.63 0 0 0 .621-.52h.016Z",
    fill: "#007E86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.075 396.034h-20.537v28.76h20.537v-28.76Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.075 449.241h-41.076v-38.559l20.538-14.648 20.538 14.648v38.559Z",
    fill: "#003381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.596 449.241h-41.058v-38.559l20.537-14.648 20.521 14.648v38.559Z",
    fill: "#0075C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.978 429.257H171.39v19.984h10.588v-19.984Z",
    fill: "#003381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.103 411.622c-1.61-1.158-3.859-.822-5.268.587l-1.158 1.158-1.158-1.158c-1.392-1.392-3.658-1.745-5.268-.587a3.976 3.976 0 0 0-.504 6.057l2.785 2.786 3.407 3.406a1.031 1.031 0 0 0 1.459 0l3.407-3.406 2.785-2.786a3.976 3.976 0 0 0-.503-6.057h.016Z",
    fill: "#FFC50A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.679 423.753h-8.054v13.273h8.054v-13.273Z",
    fill: "#0075C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.045 423.753h-8.055v13.273h8.055v-13.273ZM194.044 423.753h-8.054v13.273h8.054v-13.273Z",
    fill: "#003381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.962 448.738c.218-1.326.117-2.752-.487-4.245-1.141-2.819-3.758-4.883-6.779-5.185-4.194-.42-7.802 2.315-8.775 6.124a5.344 5.344 0 0 0-1.879-.352 5.305 5.305 0 0 0-4.917 3.305.64.64 0 0 0 .588.873h21.611a.63.63 0 0 0 .621-.52h.017Z",
    fill: "#00B0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.534 410.682h-22.921v2.719h22.921v-2.719Z",
    fill: "#0075C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.613 410.682 20.689-14.648h22.769l-20.537 14.648h-22.921Z",
    fill: "#003381"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.633,
    cy: 184.655,
    r: 59.731,
    fill: "#fff",
    stroke: "#FFC50A",
    strokeWidth: 4.654
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.633,
    cy: 184.655,
    r: 50.422,
    fill: "#E2F7FF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.633,
    cy: 128.027,
    r: 11.636,
    fill: "#FFC50A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m339.131 126.181 1.088-2.205a.388.388 0 0 1 .696 0l1.088 2.205 2.433.353a.388.388 0 0 1 .215.662l-1.76 1.716.415 2.424a.388.388 0 0 1-.563.408l-2.176-1.144-2.176 1.144a.388.388 0 0 1-.563-.408l.416-2.424-1.76-1.716a.388.388 0 0 1 .215-.662l2.432-.353Z",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PlannerBadges_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.976 186.276v-25.454a.803.803 0 0 0-.822-.806c-15.56.458-27.818 14.086-26.049 30.133 1.375 12.41 11.39 22.434 23.79 23.809 16.034 1.771 29.651-10.497 30.109-26.07a.823.823 0 0 0-.806-.822h-25.433a.782.782 0 0 1-.789-.79Z",
    fill: "#352269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.111 182.181c-.426-14.292-11.926-25.802-26.222-26.228a.823.823 0 0 0-.822.806v25.453c0 .443.348.791.79.791h25.433a.803.803 0 0 0 .805-.822h.016Z",
    fill: "#00B0AC"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.473,
    cy: 110.901,
    r: 59.731,
    fill: "#fff",
    stroke: "#FFC50A",
    strokeWidth: 4.654
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.473,
    cy: 110.901,
    r: 50.422,
    fill: "#E2F7FF"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.473,
    cy: 54.273,
    r: 11.636,
    fill: "#FFC50A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m208.971 52.427 1.088-2.205a.387.387 0 0 1 .695 0l1.088 2.205 2.433.353a.388.388 0 0 1 .215.662l-1.76 1.716.415 2.423a.387.387 0 0 1-.562.41l-2.176-1.145-2.177 1.144a.387.387 0 0 1-.562-.409l.415-2.423-1.76-1.716a.388.388 0 0 1 .215-.662l2.433-.353Z",
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PlannerBadges_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.581 143.481c17.071 0 30.91-13.839 30.91-30.91 0-17.07-13.839-30.91-30.91-30.91-17.071 0-30.91 13.84-30.91 30.91 0 17.071 13.839 30.91 30.91 30.91Z",
    fill: "#352269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.148 140.916c17.071 0 30.91-13.839 30.91-30.91 0-17.071-13.839-30.91-30.91-30.91-17.071 0-30.91 13.839-30.91 30.91 0 17.071 13.839 30.91 30.91 30.91Z",
    fill: "#0075C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.148 133.78c13.13 0 23.774-10.644 23.774-23.774s-10.644-23.775-23.774-23.775-23.774 10.645-23.774 23.775c0 13.13 10.644 23.774 23.774 23.774Z",
    fill: "#FFC50A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.21 97.992-14.542 6.847c-.308.145-.56.398-.705.705l-6.847 14.542c-.578 1.247.705 2.53 1.951 1.951l14.543-6.846c.307-.145.56-.398.704-.705l6.847-14.543c.578-1.246-.704-2.529-1.951-1.95Z",
    fill: "#352269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.147 112.571a2.566 2.566 0 1 0 0-5.132 2.566 2.566 0 0 0 0 5.132Z",
    fill: "#8D83BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.67 89.447h-.018c-.748 0-1.355.607-1.355 1.355v4.264c0 .748.607 1.355 1.355 1.355h.018c.748 0 1.355-.607 1.355-1.355v-4.264c0-.748-.607-1.355-1.355-1.355ZM232.705 110.53v-.018c0-.749-.606-1.355-1.355-1.355h-4.263c-.748 0-1.355.606-1.355 1.355v.018c0 .748.607 1.355 1.355 1.355h4.263c.749 0 1.355-.607 1.355-1.355ZM211.621 130.564h.018c.749 0 1.355-.606 1.355-1.355v-4.263c0-.748-.606-1.355-1.355-1.355h-.018c-.748 0-1.355.607-1.355 1.355v4.263c0 .749.607 1.355 1.355 1.355ZM191.589 109.482v.018c0 .748.606 1.355 1.355 1.355h4.263c.748 0 1.355-.607 1.355-1.355v-.018c0-.749-.607-1.355-1.355-1.355h-4.263c-.749 0-1.355.606-1.355 1.355Z",
    fill: "#352269"
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.952,
    cy: 68.952,
    r: 59.731,
    fill: "#fff",
    stroke: "#FFC50A",
    strokeWidth: 4.654
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.951,
    cy: 68.952,
    r: 50.422,
    fill: "#E2F7FF"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.951,
    cy: 12.326,
    r: 11.636,
    fill: "#FFC50A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m61.449 10.48 1.088-2.206a.388.388 0 0 1 .696 0l1.088 2.205 2.432.353a.388.388 0 0 1 .215.662l-1.76 1.716.416 2.423a.388.388 0 0 1-.563.41l-2.176-1.145-2.176 1.144a.388.388 0 0 1-.563-.409l.415-2.423-1.76-1.716a.388.388 0 0 1 .215-.662l2.433-.353Z",
    fill: "#fff"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PlannerBadges_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.261 86.31h15.973v12.598H37.65c-2.982 0-5.39-2.425-5.39-5.43V86.31ZM48.232 52.14H32.259v-7.168c0-3.005 2.408-5.43 5.39-5.43h5.193c2.982 0 5.39 2.425 5.39 5.43v7.167Z",
    fill: "#003381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.772 39.54H37.778c.862.072 5.39 2.425 5.39 5.43v48.508c0 3.005-2.408 5.43-5.39 5.43h45.994c2.983 0 5.39-2.425 5.39-5.43V44.97c0-3.005-2.407-5.43-5.39-5.43Z",
    fill: "#0075C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.898 86.997-6.217.507.504-6.281L89.63 60.625l5.714 5.774-20.446 20.598Z",
    fill: "#003381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.612 56.135 3.189 3.212c.699.704.699 1.856 0 2.56l-4.46 4.492-5.73-5.772 4.46-4.492a1.793 1.793 0 0 1 2.541 0Z",
    fill: "#0075C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.393 54.02.862.344c.252.109.252.47 0 .561l-.862.344a3.736 3.736 0 0 0-2.102 2.118l-.342.869c-.108.253-.467.253-.557 0l-.341-.87a3.736 3.736 0 0 0-2.102-2.117l-.863-.344c-.251-.108-.251-.47 0-.56l.863-.345a3.736 3.736 0 0 0 2.102-2.117l.341-.87c.108-.253.467-.253.557 0l.342.87a3.736 3.736 0 0 0 2.102 2.117ZM69.254 63.523l1.977.779c.574.235.574 1.067 0 1.285l-1.977.778a8.544 8.544 0 0 0-4.797 4.833l-.772 1.99c-.234.58-1.06.58-1.276 0l-.773-1.99a8.544 8.544 0 0 0-4.797-4.833l-1.976-.778c-.575-.236-.575-1.068 0-1.285l1.976-.779a8.544 8.544 0 0 0 4.797-4.832l.773-1.992c.233-.579 1.06-.579 1.276 0l.772 1.992a8.544 8.544 0 0 0 4.797 4.832Z",
    fill: "#FFC50A"
  }))), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.234,
    cy: 515.851,
    r: 59.731,
    fill: "#fff",
    stroke: "#FFC50A",
    strokeWidth: 4.654
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.236,
    cy: 515.851,
    r: 50.422,
    fill: "#E2F7FF"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.235,
    cy: 459.222,
    r: 11.636,
    fill: "#FFC50A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m282.733 457.375 1.088-2.205a.388.388 0 0 1 .695 0l1.088 2.205 2.433.353a.388.388 0 0 1 .215.662l-1.76 1.716.415 2.423a.387.387 0 0 1-.562.409l-2.177-1.145-2.176 1.145a.387.387 0 0 1-.562-.409l.415-2.423-1.76-1.716a.388.388 0 0 1 .215-.662l2.433-.353Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M309.537 495.81c-6.626-4.714-15.945-3.326-21.722 2.367l-4.763 4.694-4.763-4.694c-5.777-5.693-15.096-7.081-21.722-2.367-8.449 6-9.153 17.693-2.112 24.631l11.492 11.326 14.082 13.877c1.656 1.632 4.348 1.632 6.026 0l14.081-13.877 11.493-11.326c7.041-6.938 6.337-18.631-2.112-24.631h.02Z",
    fill: "#0075C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m319.129 490.889 1.214.467a.42.42 0 0 1 0 .779l-1.214.467a5.157 5.157 0 0 0-2.957 2.907l-.475 1.194c-.141.346-.652.346-.792 0l-.476-1.194a5.159 5.159 0 0 0-2.956-2.907l-1.215-.467a.42.42 0 0 1 0-.779l1.215-.467a5.159 5.159 0 0 0 2.956-2.907l.476-1.194c.14-.346.651-.346.792 0l.475 1.194a5.157 5.157 0 0 0 2.957 2.907ZM268.874 523.824l2.763 1.073c.81.311.81 1.453 0 1.765l-2.763 1.073c-3.08 1.194-5.526 3.599-6.741 6.627l-1.091 2.717c-.317.796-1.478.796-1.795 0l-1.091-2.717c-1.215-3.028-3.661-5.433-6.741-6.627l-2.764-1.073c-.809-.312-.809-1.454 0-1.765l2.764-1.073c3.08-1.194 5.526-3.599 6.741-6.628l1.091-2.716c.317-.796 1.478-.796 1.795 0l1.091 2.716c1.215 3.029 3.661 5.434 6.741 6.628Z",
    fill: "#FFC50A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.138 61.072c24.684 0 2.086 45.467 27.318 42.725m119.751 0c12.068 29.62 69.49-2.743 66.747 15.907m5.824 126.971c-23.586 25.78 15.585 64.464-13.486 64.464m-165.123 47.173c-5.485-29.072 42.785-10.422 42.785-47.173m20.224 110.863c0 41.688 53.278-2.804 53.278 28.462m67.596 64.483c30.358 11.131-11.098-70.835 30.358-70.835",
    stroke: "#FFC50A",
    strokeWidth: 3.483,
    strokeLinecap: "round",
    strokeDasharray: "6.97 6.97"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "PlannerBadges_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(235.072 276.913)",
    d: "M0 0h64.385v64.385H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PlannerBadges_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(129.074 396.034)",
    d: "M0 0h76.463v53.207H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PlannerBadges_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(311.933 155.953)",
    d: "M0 0h58.179v58.179H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PlannerBadges_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(178.669 79.096)",
    d: "M0 0h64.385v64.385H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PlannerBadges_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(32.26 39.543)",
    d: "M0 0h68.076v59.368H0z"
  })))));
};
export default SvgPlannerBadges;